import axiosService from "common/axiosService";
import { API_URL } from "common/defines";
import { renderQuery } from "common/utils";

export const getCustomers = async (query) =>
    await axiosService.get(API_URL + "/users" + renderQuery(query));

export const deleteCustomer = async (id) =>
    await axiosService.delete(API_URL + "/users/" + id);
